import { Logo } from '@perch-labs/shrike';
import { PropsWithChildren } from 'react';

export const LogoListItem = ({ children }: PropsWithChildren<{}>) => (
  <li>
    <Logo
      margin={{ top: '8px', left: '8px', right: '8px' }}
      scale={1}
      type="node"
      variant="accent"
    />
    {children}
  </li>
);
